const tabGroups = ['personalInfo', 'documents', 'employment'];

export default tabGroups;
